/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { menuDeltaProductSchema } from "./menuDeltaProductSchema.ts";

export const updateMenuDeltaSchema = z.object({
	groupId: z.uuid(),
	plugin_key: z.string(),
	baseHash: z.string().max(64),
	newHash: z.string().max(64),
	changed: z.array(menuDeltaProductSchema).optional(),
	removed: z.array(z.uuid()).optional(),
	sizes: z.array(z.uuid()).nullish(),
});
